<template lang="pug">
.section-nossos-pilares
  .content
    h2.titulo
      | Nossos 
      span.destaque Pilares
      .linha-verde
    .pilares-grid
      .pilar-card(
        v-for="(pilar, index) in pilares" 
        :key="pilar.id" 
        @mouseenter="hoveredCard = pilar.id" 
        @mouseleave="hoveredCard = null"
      )
        .icon-container
          .icon
            LucideIcon(:name="pilar.icon" :size="32")
        h3.pilar-titulo {{ pilar.titulo }}
        p.pilar-texto {{ pilar.texto }}
        .linha-gradiente
</template>

<script>
export default {
  name: 'NossosPilares',
  data() {
    return {
      hoveredCard: null,
      pilares: [
        {
          id: 'missao',
          icon: 'Target',
          titulo: 'Missão',
          texto: 'Criar um ambiente colaborativo para que profissionais de TI possam destacar e avaliar coletivamente suas competências técnicas.'
        },
        {
          id: 'visao',
          icon: 'Eye',
          titulo: 'Visão',
          texto: 'Ser a principal plataforma de exibição de habilidades técnicas da comunidade de TI.'
        },
        {
          id: 'valores',
          icon: 'Heart',
          titulo: 'Valores',
          texto: 'Inovação • Colaboração • Integridade • Responsabilidade'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.section-nossos-pilares {
  padding: 80px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1400px;
  width: 100%;
  box-sizing: border-box;

  .content {
    text-align: center;

    .titulo {
      font-size: 48px;
      font-weight: 700;
      color: #f5f5f5;
      margin-bottom: 64px;
      position: relative;
      margin-top: 0;

      .destaque {
        color: #6dd708;
        text-shadow: rgba(109, 215, 8, 0.5) 0px 0px 10px;
      }

      .linha-verde {
        width: 80px;
        height: 4px;
        background: linear-gradient(to right, transparent, #6dd708, transparent);
        margin: 16px auto 0;
        border-radius: 2px;
      }
    }

    .pilares-grid {
      display: flex;
      gap: 32px;
    }

    .pilar-card {
      background: linear-gradient(45deg, transparent, rgba(109, 215, 8, 0.2), transparent);
      border: 1px solid rgba(109, 215, 8, 0.2);
      border-radius: 16px;
      padding: 30px;
      text-align: center;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      cursor: pointer;
      box-sizing: border-box;
      backdrop-filter: blur(5px);

      &:hover {
        transform: scale(1.05);

        .icon {
          background-color: rgba(109, 215, 8, 0.2);
        }
        
        .pilar-titulo {
          color: #6dd708;
        }
        
        .pilar-texto {
          color: #f5f5f5;
        }
        
        .linha-gradiente{
          background: linear-gradient(to right, transparent, #6dd708, transparent);
        }
      }

      .icon-container {
        margin-bottom: 24px;
      }

      .icon {
        background: rgba(80, 80, 80, 0.2);
        transition: all 0.3s ease;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 64px;
        border-radius: 64px;
        color: #6dd708;
      }

      .pilar-titulo {
        font-size: 24px;
        font-weight: 700;
        color: #e5e5e5;
        margin-bottom: 20px;
        transition: color 0.3s ease;
      }

      .pilar-texto {
        max-width: 308px;
        font-size: 16px;
        line-height: 1.5;
        color: #969992;
        transition: color 0.3s ease;
        margin-bottom: 24px;
      }

      .linha-gradiente {
        width: 48px;
        height: 4px;
        background: linear-gradient(to right, transparent, #50505080, transparent);
        margin: 0 auto;
      }
    }
  }

  @keyframes slideIn {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    .content {
      .titulo {
        font-size: 36px;
      }

      .pilares-grid {
        gap: 24px;
      }

      .pilar-card {
        padding: 32px 24px;
      }
    }
  }

  @media (max-width: 540px) {
    .content {
      .pilares-grid {
        flex-direction: column;
        gap: 24px;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 60px 16px;

    .content {
      .titulo {
        font-size: 28px;
      }

      .pilar-card {
        //padding: 24px 20px;

        .pilar-titulo {
          font-size: 20px;
        }

        .pilar-texto {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
